import { render, staticRenderFns } from "./StreamGreen.vue?vue&type=template&id=65865496&scoped=true"
import script from "./StreamGreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreamGreen.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StreamGreen.vue?vue&type=style&index=0&id=65865496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65865496",
  null
  
)

export default component.exports